import React, { useState } from 'react'
import { Button, Popover } from '@mui/material'

import ViewColumn from '@mui/icons-material/ViewColumn'
import SelectCoumnsAutoComplete, {
  SelectColumnsAutoCompleteProps
} from './SelectCoumnsAutoComplete'

export interface SelectColumnsProps {
  handleChangeColumns: (columns: string[]) => void
  columns: SelectColumnsAutoCompleteProps['list']
  defaultColumns: string[]
}

const SelectColumns = React.memo((props: SelectColumnsProps) => {
  const { handleChangeColumns, columns, defaultColumns } = props
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'columns-select-popover' : undefined

  return (
    <>
      <Button
        size='large'
        variant='text'
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        onClick={handleClick}
        aria-describedby={id}>
        <ViewColumn sx={{ color: 'rgba(0, 0, 0, 0.56)' }} />
      </Button>
      <Popover
        id={id}
        open={open}
        keepMounted
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}>
        <SelectCoumnsAutoComplete
          defaultValue={defaultColumns}
          list={columns}
          onChange={handleChangeColumns}
        />
      </Popover>
    </>
  )
})

export default SelectColumns
